import * as React from 'react';
export var IconContext = /*#__PURE__*/React.createContext({});